import { useQuery } from "@tanstack/react-query";
import { request } from "../../../services/axios.service";
import { apiUrls } from "../../api-urls";

const get = async () => {
  const response: TServerResponse = await request({
    url: apiUrls.pagesContent.FETCH_PAGES_CONTENT,
    method: "GET",
  });
  return response;
};

export const usePagesContentQuery = () => {
  return useQuery({
    queryKey: [apiUrls.pagesContent.FETCH_PAGES_CONTENT],
    queryFn: get,
  });
};
